
$.ajaxSetup({ // Make sure that every Ajax request sends the CSRF token
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

/**
 * @param makeDisable Disable/Enable the button
 * @param showLoading Show/Hide the loading icon
 * @param iconClass
 * @param showIconAfter
 */
$.fn.btnStatus = function(makeDisable, showLoading = false, iconClass = ' fa-spinner fa-spin', showIconAfter = true){

    let $this = $(this);
    let $icon = $this.find('i.fas');
    if(!$icon.length){
        $icon = $this.parent().find('i.fas');
    }
    if($icon.length){
        $icon.remove();
    }
    if(makeDisable){
        $(this).addClass("disabled").attr('disabled', true).css('cursor', 'not-allowed');
    }else{
        $(this).removeClass("disabled").attr('disabled', false).css('cursor', 'pointer');
    }
    if(showLoading){
        if(showIconAfter){
            $(this).after('<i class="fas' + iconClass + ' ml-2"></i>')
        }else{
            $(this).append('<i class="fas' + iconClass + ' ml-2"></i>')
        }
    }
}

$.fn.ajaxErrors = function(jqXHR) {
    let $thisForm = $(this);
    let responseJSON = jqXHR.responseJSON;

    let message = 'Unknown error';
    if(jqXHR.statusText){
        message = (jqXHR.status ? "Error code: " + jqXHR.status + " - " : "") + jqXHR.statusText;
    }

    if (responseJSON) {
        if(responseJSON.errors){
            $.each(responseJSON.errors, function (k, v) {
                let $this = $("#" + k.toString().replace(/\./g, '_'));
                $this = $this.length ? $this : $('[name="' + k + '"]');
                if ($this.length) {
                    if($this.siblings("span.text-danger").length){
                        $this.siblings("span.text-danger").text(v[0]);
                    }else if($this.closest(".col").length){
                        $this.closest(".col").find("span.text-danger").text(v[0]);
                    }

                    let $dropdown = $this.closest("div.dropdown");
                    if($dropdown.length){
                        if(!$dropdown.hasClass("is-invalid")){
                            $dropdown.addClass("is-invalid");
                        }
                        return;
                    }

                    let $select2 = $this.next("span.select2").find('.select2-selection');
                    if($select2.length){
                        if(!$select2.hasClass("is-invalid")){
                            $select2.addClass("is-invalid");
                        }
                        return;
                    }
                    $this.addClass("is-invalid");
                }
            });
        }

        if(jqXHR.status === 424 && responseJSON.dependency){
            let data = responseJSON.dependency;

            swal({
                title: data.title,
                html: data.html,
                showCancelButton: data.ignoreForceDelete ? false : true,
                confirmButtonText: data.confirmButtonText,
                confirmButtonColor: data.confirmButtonColor ? data.confirmButtonColor : '#f8bb86',
                cancelButtonText: 'Close',
                cancelButtonColor: '#4dbd74',
                showCloseButton: false,
                type: data.type,
                allowOutsideClick: false,
                width: '800px'
            }).then((result) => {
                if (result.value) {
                    if(data.ignoreForceDelete){

                    }else{
                        swal({
                            title: 'Deleting data in progress !!!',
                            html: 'Please Wait ...',
                            allowOutsideClick: false,
                            onBeforeOpen: () => {
                                swal.showLoading()
                            },
                        });
                        let buttonForceDelete = $(data.buttonForceDelete);
                        let inputForceDelete = $(this).find('[name="force_delete"]');
                        if(buttonForceDelete.length && inputForceDelete.length){ // perform force delete
                            inputForceDelete.val(1);
                            buttonForceDelete.click();
                        }
                    }
                } else {
                    swal({ // reload the page
                        title: '',
                        html: 'Please Wait ...',
                        allowOutsideClick: false,
                        onBeforeOpen: () => {
                            swal.showLoading()
                        },
                    });
                    setTimeout(function(){location.reload()}, 2000);
                }
            });
            return;
        }
        if (responseJSON.message) {
            message = responseJSON.message;
            if(jqXHR.status === 419){
                swal({ // reload the page
                    title: message,
                    html: 'Reloading page, please wait ...',
                    allowOutsideClick: false,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
                setTimeout(function(){location.reload()}, 2000);
                return;
            }
        }
    }

    let $generalMessageHTML = $thisForm.find("span.error-general.text-danger");
    if($generalMessageHTML.length){
        $generalMessageHTML.text(message);
    }else{
        Toast.fire({
            type: 'error',
            title: message
        });
    }
};

$.fn.btnAjax = async function(table = false, $modal = null, CKEDITOR = null, showToast = true, files = null, $thisForm = null) {
    let $this = $(this);

    $this.btnStatus(true, true, ' fa-spinner fa-spin', false);
    $thisForm = $thisForm ? $thisForm : $this.closest("form");

    let $errorMessages = $thisForm.find("span.text-danger");
    if($errorMessages.length){
        $errorMessages.text('');
    }
    let $errorInputs = $thisForm.find(".is-invalid");
    if($errorInputs.length){
        $errorInputs.removeClass('is-invalid');
    }

    if(CKEDITOR){
        for (let instance in CKEDITOR.instances ) {
            CKEDITOR.instances[instance].updateElement();
        }
    }

    let formData = new FormData($thisForm[0]);
    if(files && Object.keys(files).length){
        $.each(Object.keys(files), function(k, name){
            formData.append(name,files[name].blob, files[name].filename);
        });
    }
    let status = 0;
    let model_id = null;
    let model = null;
    let htmlRender = null;

    try{

        let $btnCancel = $('.btn-cancel');
        if($btnCancel.length){
            $btnCancel.hide('slow');
        }
        await $.ajax({
            url : $thisForm.attr('action'),
            type : $thisForm.attr('method'),
            data: formData,
            async: true,
            cache: false,
            contentType: false,
            processData: false,
            success : function(response) {

                if(response.htmlRender){
                    htmlRender = response.htmlRender;
                }
                let hasUploadFiles = false;
                let $videoFile = $("input#video_file");
                let hasVideoFile = $videoFile.length && $videoFile[0].files.length > 0;
                if(!hasVideoFile){
                    jQuery.map($thisForm.find('[type="file"]'), function(item) {
                        if(!hasUploadFiles){
                            hasUploadFiles = $(item)[0].files.length > 0;
                        }
                    })
                }
                let message = response.message ? response.message : 'Success';
                if(response.swal){
                    let swalData = response.swal;
                    swal(swalData).then((response) => {
                            swal({
                                title: 'Please Wait !',
                                html: 'The page will refresh now ...',
                                allowOutsideClick: false,
                                onBeforeOpen: () => {
                                    swal.showLoading()
                                },
                            });
                            setTimeout(function(){
                                window.location.reload();
                            }, 1500);
                        });
                    return;
                }
                if(response.redirectTo && !hasVideoFile){
                    swal({
                        title: 'Please Wait ...',
                        html: message,
                        allowOutsideClick: false,
                        onBeforeOpen: () => {
                            swal.showLoading()
                        },
                    });

                    setTimeout(function(){
                        if(response.newTab){
                            window.open(response.redirectTo, '_blank');
                            swal.close()
                        }else{
                            window.location.replace(response.redirectTo);
                        }
                    }, 2000);
                    if(!response.reload)
                        return;
                }
                if(response.reload || hasUploadFiles){
                    swal({
                        title: 'Refreshing the page, please wait ...',
                        html: message,
                        allowOutsideClick: false,
                        onBeforeOpen: () => {
                            swal.showLoading()
                        },
                    });
                    setTimeout(function(){
                        window.location.reload();
                    }, 2000);
                    return;
                }
                if(table){
                    table.ajax.reload();
                }
                if($modal){
                    $modal.modal('hide');
                }
                if(showToast){
                    Toast.fire({
                        type: 'success',
                        title: message
                    });
                }
                if(response.model_id){ model_id = response.model_id; }
                if(response.model){ model = response.model; }

                let inputForceDelete = $thisForm.find('[name="force_delete"]');
                if(inputForceDelete.length){
                    inputForceDelete.val("0");
                }
            },
            error: function (jqXHR) {
                $thisForm.ajaxErrors(jqXHR);
            },
            complete: function(r){
                $this.btnStatus(false, false);
                status = r.status;
            }
        });
    }catch (e) {
        console.log(e);
    }

    return {status: status, model: model, model_id: model_id, htmlRender: htmlRender};
}

$.fn.btnAjaxDelete = async function(route, title) {
    let $this = $(this);
    let requestSent = false;
    await swal({
            title: title,
            text: "",
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            showCloseButton: true,
            type: "info",
            allowOutsideClick: true
        }
    ).then(async (response) => {
        if (response.value) {
            swal({
                title: 'Please Wait !',
                html: 'Sending the request ...',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    swal.showLoading()
                },
            });
            await $.post(route, {media_id: $this.data('media-id')}, function (data, status) {

                if (data.success) {
                    requestSent = true;
                    swal({
                        title: "Deleted!",
                        text: "Your media has been deleted.",
                        type: "success",
                        timer: 3000
                    });
                    let $fileDiv = $this.closest('p.form-group');
                    $fileDiv = $fileDiv.length ? $fileDiv : $this.closest('.media-video');
                    $fileDiv = $fileDiv.length ? $fileDiv : $this.closest('div.col');
                    if($fileDiv.length){
                        $fileDiv.remove();
                    }
                    let $inputTextByID = $($this.data("clear-by-id"));
                    if($inputTextByID.length){
                        $($inputTextByID).val('');
                    }
                } else {
                    swal({
                        title: 'Something Went Wrong',
                        allowOutsideClick: true,
                        type: "error",
                        showCloseButton: true,
                    });
                }
            });
        }
    });
    return requestSent;
}

$.fn.initCkeditor = function() {
    $(this).each(function () {
        let $this = $(this);
        let wordCountConf = {};

        if($this.data("max")){
            wordCountConf = {
                showParagraphs: false,
                showWordCount: true,
                showCharCount: true,
                countSpacesAsChars: true,
                countHTML: true,
                maxWordCount: -1,
                maxCharCount: $this.data("max")};
        }

        CKEDITOR.replace($this.attr("id"), {
            wordcount: wordCountConf,
            filebrowserImageBrowseUrl: '/laravel-filemanager?type=Images',
            filebrowserBrowseUrl: '/laravel-filemanager?type=Files',
            extraPlugins: 'smiley,lineutils,widget,codesnippet,prism,flash,wordcount,notification',
        });
    });
}

let $newsletterPopup = $('#newsletter_popup');
if($newsletterPopup.length && $newsletterPopup.data('status') && window.localStorage.getItem('newsletterPopup') === null){
    setTimeout(function(){
        let newsletterPopup = function() {
            swal({
                    title: '',
                    html: "</br><span style='font-weight: bold'>Subscribe to our Newsletter for all Course Updates, News and Insights</span>",
                    input: 'email',
                    inputAttributes: {
                        placeholder: 'Enter your email',
                        required: true
                    },
                    showCancelButton: false,
                    confirmButtonText: 'Subscribe',
                    showCloseButton: true,
                    allowOutsideClick: false,
                }
            ).then((response) => {
                window.localStorage.setItem('newsletterPopup', 'set'); // store the name so it will not show again on this browser
                newsletterResponse(response);
            });
        }

        newsletterPopup();

        let newsletterResponse = function (response){
            if (response.value) {
                swal({
                    title: 'Please Wait !',
                    html: 'Sending the request ...',
                    allowOutsideClick: false,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });

                $.post('/newsletter/subscribe', {subs_email: response.value})
                    .done(function(response) {
                        swal({
                            title: 'Please check you email and confirm subscription',
                            text: '',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: 'success',
                            allowOutsideClick: false,
                            timer: 8000
                        });
                    })
                    .fail(function(response) {
                        let message = response.responseJSON
                            ? response.responseJSON.exception
                                ? false
                                : response.responseJSON.message
                                    ? response.responseJSON.message
                                    : false
                            : false
                        swal({
                            type: 'error',
                            title: message ? message : 'Subscribe to Newsletter Failed',
                            text: '',
                            showCancelButton: false,
                            confirmButtonText: 'Try Again',
                            showCloseButton: true,
                            allowOutsideClick: false,
                        }).then((response) => {
                            newsletterPopup();
                        });
                    })
                    .always(function(response) {
                    });
            }
        }

    }, isNaN($newsletterPopup.data('timeout')) ? 120000 : $newsletterPopup.data('timeout')*1000);
}


// Read a page's GET URL variables and return them as an associative array.
$.fn.getUrlVars = function (paramName) {
    let vars = [], hash, url = $(this).attr('href');
    let hashes = url.slice(url.indexOf('?') + 1).split('&');
    for(let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    if(paramName){
        return vars[paramName];
    }
    return vars;
}


function maxClonable($mainClonable) {
    let maxBlocks = 4; // the max quiz options can be added - default to 4
    if ($mainClonable.data('max-block')) {
        maxBlocks = $mainClonable.data('max-block'); // getting the max quiz options from the element
    }
    return maxBlocks;
}

$.fn.clanableRemove = function () {
    let $thisBtn = $(this);

    let $mainClonable = $thisBtn.closest('[data-toggle="cloner"]');
    let maxBlocks = maxClonable($mainClonable);

    $thisBtn.closest('div.clonable')
        .css('opacity', 1)
        .slideUp('slow', function () { //slide up
            $(this).remove(); //then remove from the DOM
            $('.clonable-button-add').btnStatus($mainClonable.length >= maxBlocks);
        })
        .animate(
            {opacity: 0},
            {queue: false, duration: 'slow'}
        );
}

$.fn.clanableAdd = function (isHuman) {
    let $thisBtn = $(this);
    let $mainClonable = $thisBtn.closest('[data-toggle="cloner"]');
    let $clonableSourceLast = $mainClonable.find('div.clonable:last');
    if (isHuman) {
        $thisBtn.btnStatus(true, true, ' fa-spinner fa-spin', false);
        $clonableSourceLast.find('input, textarea').each(function(k, v){
            $(v).val('');
            $(v).html('');
        });
    }else{
        scroll(0,0);
    }
    let maxBlocks = maxClonable($mainClonable);

    let $clonableSource = $mainClonable.find('div.clonable');


    $clonableSourceLast.find("span.text-danger").text('');
    $clonableSourceLast.find('.is-invalid').removeClass("is-invalid");

    $clonableSourceLast.css('display', isHuman ? 'none' : 'block')
        .css('opacity', 0)
        .slideDown('slow', function () { //slide up
            $thisBtn.btnStatus($clonableSource.length >= maxBlocks);
        })
        .animate(
            {opacity: 1},
            {queue: false, duration: 'slow'}
        ).find('.clonable-button-remove').css('display', 'block');


    let $lastSwitch = $clonableSourceLast.find('[data-toggle="switch"]');
    if($lastSwitch.length){
        let mainParent = $lastSwitch.closest('div.form-group');
        mainParent.find('.bootstrap-switch').remove();
        mainParent.find('label.clonable-increment-for').after($lastSwitch.prop('checked', false));
        mainParent.find('[data-toggle="switch"]').bootstrapSwitch({
            onSwitchChange: function (event, state) {
                $(event.currentTarget).val(state ? 1 : 0);
            }
        });
    }
}

$(document).on('focus', '.clean-text-danger', function(){
    $(this).parent().find('span.text-danger').empty();
    $(this).parent().find('.is-invalid').removeClass('is-invalid');
})

$.fn.handleButton = function (isDisabled) {
    let $thisBtn = $(this);
    $thisBtn.attr("disabled", isDisabled);
    if(isDisabled){
        $thisBtn.addClass("disabled");
    }else{
        $thisBtn.removeClass("disabled");
    }
}


// WEBPACK FOOTER //
// ./resources/js/global-fn.js